import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-committee',
  templateUrl: './committee.component.html',
  styleUrls: ['./committee.component.scss']
})
export class CommitteeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  gotoAbout() {
    this.router.navigateByUrl('/about');
  }
  gotoAboutCriteria() {
    this.router.navigateByUrl('/about/criteria');
  }
  gotoAboutCommittee() {
    this.router.navigateByUrl('/about/committee');
  }
  gotoAboutGroups() {
    this.router.navigateByUrl('/about/groups');
  }
  gotoAboutStaff() {
    this.router.navigateByUrl('/about/staff');
  }
  gotoAboutExample1() {
    this.router.navigateByUrl('/search/plant-details/410');
  }
  gotoAboutExample2() {
    this.router.navigateByUrl('/search/plant-details/1232');
  }
  gotoAboutExample3() {
    this.router.navigateByUrl('/search/plant-details/46');
  }

}
